export const isStringVoid = (str: string): boolean => str === undefined || str === null || str.trim() === '';
export const isBlobURL = (str: string): boolean => str.startsWith('blob:');
